/**
 * @generated SignedSource<<41d2c2828ae93c13b1648d204d335c01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventMembersImportFragment$data = {
  readonly id: string;
  readonly viewerCanEditMembers: boolean;
  readonly " $fragmentType": "EventMembersImportFragment";
};
export type EventMembersImportFragment$key = {
  readonly " $data"?: EventMembersImportFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventMembersImportFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventMembersImportFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "viewerCanEditMembers",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "ADD_EVENT_MEMBER"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"ADD_EVENT_MEMBER\")"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "f90bd15ec1f9ad91249f69bd252a29e4";

export default node;
